export default __webpack_public_path__ + "static/media/arrowRightcon.ab443a52.svg";